const Card = {};
const wxBridge = WXGAME.WxBridge;
const Env = WXGAME.Env;

Card.addCard = function (card, cbk) {
  card = card || {};
  let ext = {
    timestamp: +card.timestamp
  };
  if (card.openid) {
    ext.openid = card.openid;
  }
  if (card.nonce_str) {
    ext.nonce_str = card.nonce_str;
  }
  if (card.signature) {
    ext.signature = card.signature;
  }
  if (card.code) {
    ext.code = card.code;
  }
  // console.log(card, ext);
  if (Card.isAdding) {
    return;
  }
  Card.isAdding = true;

  if (Env.isPC) {
    setTimeout(function () {
      card.success = 'ok';
      card.is_fake = true;
      if (typeof cbk == 'function') {
        cbk(card);
      }
      Card.isAdding = false;
    }, 300);
    return;
  }
  wxBridge.invoke(
    'batchAddCard',
    {
      card_list: [
        {
          card_id: card.cardId || card.card_id || card.cardid,
          card_ext: JSON.stringify(ext)
        }
      ]
    },
    function (res) {
      // res = {"err_msg": "batch_add_card:cancel","webview":{"kernal":"UIWEB/XWEB"}}
      // res = { err_msg: 'batch_add_card:ok', webview: { kernal: 'UIWEB/XWEB' } };
      // res = {"err_msg": "batch_add_card:fail","webview":{"kernal":"UIWEB/XWEB"}}
      // res = { err_msg: 'batch_add_card:ok', webview: { kernal: 'UIWEB/XWEB' } };
      // res = {
      //     err_msg: 'batch_add_card:ok',
      //     card_list:
      //         '[{"code":"5Fq9RYaFlXvVp4hZLuxPUHLKhu2YGs2b/YaVtZmVUAwf6gRGvuYNsyGUnN4SkM1r","is_succ":"1","card_ext":"{"timestamp":1579601764,"openid":"oX1sstw6H0J24UYU7jh0ly171OtM","nonce_str":"vbz6u326FrVovwdYj19jMYPfVkMec8","signature":"78097ED5607AA198F1DC44848B0C1927CAC0FAAF","code":"be552fa55e26cf64"}","card_id":"pX1sst3uwUIYQtYaYSRnYbHVFw4E"}]',
      //     webview: { kernal: 'UIWEB/XWEB' }
      // };
      // res = console.log('53', res);
      Card.isAdding = false;
      res = res || {};
      let msg = res.errMsg || res.err_msg || res.errmsg || '';
      if (res && msg.indexOf(':ok') != -1) {
        card.success = 'ok';
        console.log(61, card);
        if (typeof cbk == 'function') {
          cbk(card);
        }
      } else {
        card.success = msg.indexOf('cancel') != -1 ? 'cancel' : 'fail';
        if (typeof cbk == 'function') {
          cbk(card);
        }
      }
    }
  );
};

Card.openCard = function (card, cbk) {
  card = card instanceof Array ? card : [card];
  let list = card.map((i) => {
    return {
      card_id: i.cardId || i.cardid || i.card_id,
      code: i.code
    };
  });
  wxBridge.invoke('batchViewCard', {
    card_list: list
  });
};
export default Card;
